import { render } from "./propertiesAvatar.vue?vue&type=template&id=176e3358"
import script from "./propertiesAvatar.vue?vue&type=script&lang=js"
export * from "./propertiesAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__